import { useContext } from "react";
import { OidcContext } from "./OidcProvider";

import { IOidcApplicationPaths } from "./OidcApplicationPaths";

export const useOidcPaths = (): IOidcApplicationPaths => {
  const authService = useContext(OidcContext);
  return authService.applicationPaths();
};
